import axios from 'axios';

import { createRefreshInterceptor } from '../../../shared/api';
import { BASE_URL } from './endpoints';
import { authInterceptor, errorInterceptor, websiteInterceptor } from './interceptors';

const HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: HEADERS,
});

axiosInstance.interceptors.request.use(...authInterceptor);
axiosInstance.interceptors.request.use(...websiteInterceptor);

// An expired access token will trigger a 401 error. The refresh interceptor must be
// registered before the error interceptor so that the token is refreshed without an
// error being displayed.
const refreshInterceptor = createRefreshInterceptor(axiosInstance);
axiosInstance.interceptors.response.use(...refreshInterceptor);

axiosInstance.interceptors.response.use(...errorInterceptor);

export default axiosInstance;
